import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface Series {
  key: string
  label: string
  color: string
  domain?: [number, number]
}

interface Props {
  data: Array<Record<string, unknown>>
  xKey: string
  series: Series[]
  height?: number
}

export default function LineSeries({ data, xKey, series, height = 280 }: Props) {
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
          <CartesianGrid stroke="rgb(231 229 228)" vertical={false} />
          <XAxis dataKey={xKey} tick={{ fontSize: 11 }} stroke="rgb(168 162 158)" />
          <YAxis tick={{ fontSize: 11 }} stroke="rgb(168 162 158)" width={28} />
          <Tooltip
            contentStyle={{
              background: 'rgb(255 255 255)',
              border: '1px solid rgb(214 211 209)',
              borderRadius: 8,
              fontSize: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            }}
            labelStyle={{ color: 'rgb(28 25 23)' }}
          />
          {series.map((s) => (
            <Line
              key={s.key}
              type="monotone"
              dataKey={s.key}
              name={s.label}
              stroke={s.color}
              strokeWidth={1.5}
              dot={false}
              isAnimationActive={false}
              connectNulls
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
